import wretchAdapter from '@/shared/api/adapters/wretch';

import { setStepUpHeaders } from './util/setStepUpHeaders';

export default wretchAdapter(CONFIG.PAYROLL_API).middlewares([setStepUpHeaders]);
